import Transfer from '../../../assets/transfer.svg';

const TransferIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => {
  return <Transfer {...props} />;
};

export default TransferIcon;
